import Vue from "vue";
import Router from "vue-router";
import Startseite from "@/components/views/Startseite";
import Service from "@/components/views/Service";
import UeberUns from "@/components/views/UeberUns";
import Referenzen from "@/components/views/Referenzen";
import Kontakt from "@/components/views/Kontakt";
import Leistungen from "@/components/views/Leistungen";
import Datenschutz from "@/components/views/Datenschutz";
import Impressum from "@/components/views/Impressum";
import Kuechenarbeitsplatten from "@/components/views/Kuechenarbeitsplatten";
import Boeden from "@/components/views/Boeden";
import Treppen from "@/components/views/Treppen";
import Baeder from "@/components/views/Baeder";
import Fensterbaenke from "@/components/views/Fensterbaenke";
import Eingangsbereich from "@/components/views/Eingangsbereich";
import IndividuelleProdukte from "@/components/views/IndividuelleProdukte";
import TischeTheken from "@/components/views/TischeTheken";
import LeistungUeberblick from "@/components/views/LeistungUeberblick";
import Ausstellung from "@/components/views/Ausstellung";
import Materialien from "@/components/views/Materialien";
import Weichgesteine from "@/components/views/Weichgesteine";
import Hartgesteine from "@/components/views/Hartgesteine";
import Quarzkomposit from "@/components/views/Quarzkomposit";
import Keramik from "@/components/views/Keramik";
import UnserTeam from "@/components/views/UnserTeam";
import MaterialUeberblick from "@/components/views/MaterialUeberblick";
import UnsereWerkstatt from "@/components/views/UnsereWerkstatt";
import Materialsuche from "@/components/views/Materialsuche";

// Components used in the app
Vue.component(
  "navbar",
  require("@/components/interface/NavBar/NavBar.vue").default
);
Vue.component(
  "footer-bar",
  require("@/components/interface/Footer/Footer.vue").default
);

Vue.use(Router);

export default new Router({
  /* mode: "hash",//"abstract",
    base: 'http://localhost:8080/', */
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Startseite",
      component: Startseite
    },
    {
      path: "/service",
      name: "Service",
      component: Service
    },
    {
      path: "/ueber-uns",
      name: "Über uns",
      component: UeberUns
      /* children: [{
                path: '/naturstein-ausstellung',
                name: 'Ausstellung',
                component: Ausstellung
            }, ] */
    },
    {
      path: "/naturstein-ausstellung",
      name: "Ausstellung",
      component: Ausstellung
    },
    {
      path: "/unser-team",
      name: "Unser Team",
      component: UnserTeam
    },
    {
      path: "/unsere-werkstatt",
      name: "Unsere Werkstatt",
      component: UnsereWerkstatt
    },
    {
      path: "/referenzen",
      name: "Referenzen",
      component: Referenzen
    },
    {
      path: "/kontakt",
      name: "Kontakt",
      component: Kontakt
    },
    {
      path: "/material",
      name: "Materialien",
      component: Materialien,
      children: [
        {
          path: "natursteine-und-kunststeine",
          component: MaterialUeberblick
        },
        {
          name: "Materialsuche",
          path: "materialsuche",
          beforeEnter(to, from, next) {
            // Put the full page url including the protocol http(s) below
            window.location =
              "https://www.marmor-kunze.de/material/materialsuche";
          }
        },
        {
          name: "Weichgesteine",
          path: "weichgesteine",
          component: Weichgesteine
        },
        {
          name: "Hartgesteine",
          path: "granit-und-hartgesteine",
          component: Hartgesteine
        },
        {
          name: "Quarzkomposit",
          path: "quarzkomposit",
          component: Quarzkomposit
        },
        {
          name: "Keramik",
          path: "keramik",
          component: Keramik
        }
      ]
    },
    /* {

            path: 'ueberblick',
            component: Natursteine
        }, */
    {
      path: "/leistungen",
      name: "Leistungen",
      component: Leistungen,
      children: [
        {
          path: "ueberblick",
          component: LeistungUeberblick
        },
        {
          name: "Küchenarbeitsplatten",
          path: "naturstein-kuechenarbeitsplatten",
          component: Kuechenarbeitsplatten
        },
        {
          name: "Böden",
          path: "naturstein-boeden",
          component: Boeden
        },
        {
          name: "Treppen",
          path: "naturstein-treppen",
          component: Treppen
        },
        {
          name: "Bäder",
          path: "naturstein-waschtische-und-baeder",
          component: Baeder
        },
        {
          name: "Fensterbänke",
          path: "naturstein-fensterbank",
          component: Fensterbaenke
        },
        {
          name: "Eingangsbereich",
          path: "naturstein-eingangsbereich",
          component: Eingangsbereich
        },
        {
          name: "TischeTheken",
          path: "naturstein-tische-und-theken",
          component: TischeTheken
        },
        {
          name: "IndividuelleProdukte",
          path: "individuelle-naturstein-produkte",
          component: IndividuelleProdukte
        }
      ],
      beforeRouteUpdate(to, from, next) {
        // react to route changes...
        // don't forget to call next()
        next();
      }
    },
    {
      path: "/datenschutz",
      name: "Datenschutz",
      component: Datenschutz
    },
    {
      path: "/impressum",
      name: "Impressum",
      component: Impressum
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js